import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react'
import { useContext, usePatient } from 'hooks/useURL'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import MainDropdown from './MainDropdown.jsx'
import PatientSearch from '../PatientSearch/PatientSearch.jsx'
import TimerMenu from '../Timer/TimerMenu.jsx'
import $ from 'jquery'
import _ from 'lodash'

const DashboardMenu = ({
  allowPatientSearch,
  additionalContent,
  createPatientHandler,
  dashboardDisabled
}) => {
  const rootRef = useRef()
  const menuRef = useRef()
  const context = useContext()
  const patientId = usePatient()
  const [flexSpaceForTimers, setFlexSpaceForTimers] = useState(0)
  const pathname = useSelector(state => state.router.location.pathname)
  const clinicLocation = useSelector(state => state.appConfig.CLINIC_LOCATION) || -1
  const designMode = useSelector(state => state.interactableState.uiDesignMode);

  useEffect(() => {
    // componentDidMount
    const $ = window.jQuery
    $('.dropdown-submenu').click(function (event) {
      if (event.originalEvent.srcElement.classList[0] === 'dropdown-toggle') {
        $(this).find('.dropdown-submenu').removeClass('open')
        $(this).parents('.dropdown-submenu').addClass('open')
        $(this).toggleClass('open')
      }
    })
  }, [])

  const calculateFlexSpace = useCallback(
    _.debounce(() => {
      const $root = $(rootRef.current)
      const menuWidth = $root.innerWidth()
      const menuItemMarginWidth = 4
      const quickAccessItemMarginWidth = 6

      const nonFlexWidth = $root
        .children()
        .map(function () {
          const $flexItem = $(this)
          if ($flexItem.hasClass('quick-access-container')) {
            // this box should grow to take priority,
            // so measure children, not the box itself
            return (
              $flexItem
                .children()
                .map(function () {
                  const w = $(this).outerWidth() + quickAccessItemMarginWidth
                  return w
                })
                .get()
                .reduce((a, v) => a + v, 0) + menuItemMarginWidth
            )
          }
          if ($flexItem.hasClass('timer-menu-timers')) {
            // totally flexible, do not count
            return menuItemMarginWidth
          }
          // standard item
          return $flexItem.outerWidth() + menuItemMarginWidth
        })
        .get()
        .reduce((a, v) => a + v, 0)

      const newFlexSpaceForTimers = Math.max(
        0,
        Math.floor(menuWidth - nonFlexWidth) - 10
      )

      if (newFlexSpaceForTimers !== flexSpaceForTimers) {
        // console.debug('flexSpaceForTimers', flexSpaceForTimers)
        setFlexSpaceForTimers(newFlexSpaceForTimers)
      }
    }, 250),
    [flexSpaceForTimers]
  )

  useEffect(() => {
    calculateFlexSpace()
  }, [])

  const patientSearch = allowPatientSearch || false
  const inWorkflow = pathname.indexOf('/workflow/') !== -1

  const prefix = useMemo(() => {
    switch (context) {
      case 'patientDisplay':
        return `dashboard/patient/${patientId}`
      case 'adminDisplay':
        return 'dashboard/admin'
      case 'nurseDashboard':
        return 'dashboard'
      default:
        return ''
    }
  }, [context, patientId])

  const designModeClass = designMode ? ' design-mode' : ''
  return (
    <div ref={rootRef} className={"dashboard top-menu" + designModeClass}>
      {additionalContent != null
        ? additionalContent()
        : null}
      <div style={{ display: 'flex', alignSelf: 'stretch', alignItems: 'center', flex: '0 0 auto' }}>
        {patientSearch
          ? (
            <React.Fragment>
              <TimerMenu
                flexSpaceForTimers={flexSpaceForTimers}
                clinicLocation={clinicLocation}
              />
              <div style={{ display: 'flex', width: '190px', height: '100%' }}>
                <PatientSearch
                  createPatientHandler={createPatientHandler}
                  placeholder="Patient name"
                  disabled={inWorkflow}
                  floatResults={true}
                />
              </div>
            </React.Fragment>
          )
          : null}
        <div ref={menuRef} className="main-menu-button">
          <MainDropdown
            prefix={prefix}
            inWorkflow={inWorkflow}
            dashboardDisabled={dashboardDisabled}
          />
        </div>
      </div>
    </div>
  )
}

DashboardMenu.propTypes = {
  // A function that when run will return additional content to be displayed
  // in the top menu
  additionalContent: PropTypes.func,
  // Show patient search box?
  allowPatientSearch: PropTypes.bool,
  // An optional doIntro function that will be run when the i button is pressed
  doIntro: PropTypes.func
  // If used on patient screen during a workflow, this allows menu options to be disabled in
}

export default DashboardMenu
